module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionNjyh.e6e3ec61.png";